import React from 'react'
import DeleteReleaseNoteModal from './DeleteReleaseNoteModal'
import { RELEASE_NOTES_MODAL_TYPES } from './ReleaseNotesModals.constants'

const ReleaseNoteModal = (modalName) => {
	switch (modalName) {
		case RELEASE_NOTES_MODAL_TYPES.DELETE_RELEASE_NOTE_MODAL:
			return <DeleteReleaseNoteModal />
		default:
			return null
	}
}

export default ReleaseNoteModal
